import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import AboutGalleryAdmin from "./AboutGalleryAdmin";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AboutAdmin() {
  const [form, setForm] = useState({ title: "", text: "" });
  const [imageUrl, setImageUrl] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    api.get("/about").then(({ data }) => {
      setForm({ title: data.title, text: data.text });
      setImageUrl(data.image_url);
      setGallery(data.gallery || []);
    }).catch(() => toast.error("No se pudo cargar Sobre mí"));
  }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/about", form); toast.success("Sobre mí guardado ✦"); }
    catch (e) { toast.error(e?.response?.data?.detail || "No se pudo guardar"); }
    finally { setSaving(false); }
  };

  const upload = async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      const { data } = await api.post("/admin/about/image", fd);
      setImageUrl(data.image_url);
      toast.success("Imagen actualizada ✦");
    } catch (e) { toast.error(e?.response?.data?.detail || "No se pudo subir la imagen"); }
    finally { setUploading(false); }
  };

  const removeImage = async () => {
    if (!window.confirm("¿Quitar la imagen de Sobre mí?")) return;
    try {
      await api.delete("/admin/about/image");
      setImageUrl(null);
      toast.success("Imagen quitada");
    } catch { toast.error("No se pudo quitar la imagen"); }
  };

  return (
    <div data-testid="about-admin" className="grid md:grid-cols-[1fr_2fr] gap-10 max-w-5xl">
      <div className="space-y-4">
        <p className="overline">Imagen</p>
        {imageUrl ? (
          <img data-testid="about-admin-image" src={`${BACKEND_URL}${imageUrl}`} alt="Sobre mí"
            className="w-full aspect-[4/5] object-cover border border-white/10" />
        ) : (
          <div className="w-full aspect-[4/5] border border-dashed border-white/15 flex items-center justify-center text-zinc-600 text-sm">
            Sin imagen
          </div>
        )}
        <label className="btn-ghost inline-block cursor-pointer text-sm">
          {uploading ? "Subiendo…" : imageUrl ? "Cambiar imagen" : "Subir imagen"}
          <input type="file" accept="image/*" data-testid="about-image-upload" className="hidden" disabled={uploading}
            onChange={(e) => { const f = e.target.files?.[0]; if (f) upload(f); e.target.value = ""; }} />
        </label>
        {imageUrl && (
          <button data-testid="about-image-remove" onClick={removeImage}
            className="block text-xs text-zinc-500 hover:text-red-400">Quitar imagen</button>
        )}
      </div>
      <div className="space-y-5">
        <div>
          <label className="field-label">Título</label>
          <input data-testid="about-title-input" className="input-field" value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })} />
        </div>
        <div>
          <label className="field-label">Texto</label>
          <textarea data-testid="about-text-input" rows={16} className="input-field" value={form.text}
            onChange={(e) => setForm({ ...form, text: e.target.value })}
            placeholder="Cuéntales quién eres, tu camino en la astrología…" />
        </div>
        <button data-testid="about-save" onClick={save} disabled={saving} className="btn-lilac">
          {saving ? "Guardando…" : "Guardar ✦"}
        </button>
      </div>
      <AboutGalleryAdmin gallery={gallery} setGallery={setGallery} />
    </div>
  );
}
